
<template>
	<div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" align="center" ></compFormQuery>
			<compFormEdit v-else ref="relation" class="margin-layout" :formdata="getBase" v-model="formData" align="center"/>
		</compWrapper>
		<compWrapper title="操作历史" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
        <div class="text-right">
			<vButton v-if="!query" theme="primary" class="width-15per" @click="submit">保存</vButton>
            <vButton v-if="!query" class="width-15per margin-left-10" @click="cancel">返回</vButton>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpGetPaybillPeriodOne, HttpSavePaybillPeriodOne } from "@/service/chargescalc";
import { mapGetters } from "vuex";
import mixin from '../mixin'

export default {
    props:['activeid','querytype'],
    mixins: [ mixin ],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading:false,
			type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
			opLogList: [],
			formData: {},
            oldendTime:'',
		}
	},
	created() {
		this.query = this.type === "query";
		if (this.type == 'edit' || this.type == 'query') {
			this.getDetail()
		}
	},
	computed: {
        ...mapGetters('dictionary', ['getBillcusWareList', 'getCusBillTypeList','getWarehouseList']),
		getBase() {
            let showquery = this.type == 'query' || this.type == 'edit'
			return [
				{
                    label: "仓库",
                    key: "warehouseCode",
                    tag: "vSelect",
                    options:this.warehouseList.map(item=>{
                        return {
                            value: item.code,
                            label: item.label
                        }
                    }),
                    query:true
                },
                {
					label: "账期描述",
                    key: "code",
                    tag: "vInput",
                },
                {
					label: "开始日期",
                    key: "startTime",
                    tag: "vDatepicker",
                    props:{
                        format:'yy-mm-dd',
                        confirm:false,
                    },
                },
                {
					label: "结束日期",
                    key: "endTime",
                    tag: "vDatepicker",
                    props:{
                        format:'yy-mm-dd',
                        confirm:false,
                    },
                    on:{
                        'on-change':(val)=>{
                            this.timecmp(val)
                        }
                    }
                },
			];
        },
	},
	methods: {
        timecmp(val){
            if(this.compareFN1(this.oldendTime,val)>0){
                this.$VMessage.error('不能选择小于当前时间'+this.oldendTime);
                return
            }
        },
        compareFN1(date1, date2) {//比较日期大小函数
            let oDate1 = new Date(date1);
            let oDate2 = new Date(date2);
            if (oDate1.getTime() < oDate2.getTime()) {
                return -1;
            } else if (oDate1.getTime() > oDate2.getTime()) {
                return 1;
            } else {
                return 0;
            }
        },
		async getDetail() {
            this.loading = true;
            HttpGetPaybillPeriodOne({
                id: this.id
            }).then(res => {
                this.formData = res.data
                this.oldendTime = res.data.endTime;
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
			});
		},
		submit(){
            if(this.compareFN1(this.oldendTime,this.formData.endTime)>0){
                this.$VMessage.error('不能选择小于当前时间'+this.oldendTime);
            }else{
                HttpSavePaybillPeriodOne({
                    ...this.formData
                }).then(res=>{
                    this.loading = false
                    this.$VMessage.success(res.message)
                    this.cancel()
                },err=>{
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                    this.loading = false
                })
            }
		},
		cancel(){
			this.$router.push({ name: "paymentmaintainPricemaintain" })
		}
	},
}
</script>
